export class Banking {
  constructor(props) {
    return [
      { code: "000", name: "พร้อมเพย์", name_en: "PromptPay" },
      { code: "002", name: "ธนาคารกรุงเทพ", name_en: "Bangkok Bank" },
      { code: "004", name: "ธนาคารกสิกรไทย", name_en: "Kasikorn Bank" },
      { code: "006", name: "ธนาคารกรุงไทย", name_en: "Krung Thai Bank" },
      { code: "011", name: "ธนาคารทหารไทย", name_en: "Thai Military Bank" },
      {
        code: "014",
        name: "ธนาคารไทยพาณิชย์",
        name_en: "Siam Commercial Bank"
      },
      {
        code: "025",
        name: "ธนาคารกรุงศรีอยุธยา",
        name_en: "Bank of Ayudhya"
      },
      {
        code: "030",
        name: "ธนาคารออมสิน",
        name_en: "Government Savings Bank"
      },
      {
        code: "033",
        name: "ธนาคารอาคารสงเคราะห์",
        name_en: "Government Housing Bank"
      },
      {
        code: "034",
        name: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        name_en: "Bank for Agriculture and Agricultural Cooperatives"
      },
      { code: "065", name: "ธนาคารธนชาต", name_en: "Thanachart Bank" },
      {
        code: "069",
        name: "ธนาคารเกียรตินาคิน",
        name_en: "Kiatnakin Bank"
      },
      { code: "022", name: "ธนาคารซีไอเอ็มบีไทย", name_en: "CIMB" },
      {
        code: "066",
        name: "ธนาคารอิสลามแห่งประเทศไทย",
        name_en: "Islamic Bank (Thailand)"
      },
      { code: "067", name: "ธนาคารทิสโก้", name_en: "TISCO Bank" },
      { code: "024", name: "ธนาคารยูโอบี", name_en: "UOB" },
      {
        code: "073",
        name: "ธนาคารแลนด์ แอนด์ เฮาส์",
        name_en: "Land and House Bank"
      },
      {
        code: "070",
        name: "ธนาคารไอซีบีซี (ไทย)",
        name_en: "ICBC (Thailand)"
      },
      {
        code: "COEBLALA",
        name: "BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC (BCEL)",
        name_en: "BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC (BCEL)"
      },
      {
        code: "LDBBLALA", 
        name: "Lao Development Bank Co.,Ltd (LDB)",
        name_en: "Lao Development Bank Co.,Ltd (LDB)"
      },
      {
        code: "BFLLLALA",
        name: "Banque Franco-Lao Ltd (BFL)", 
        name_en: "Banque Franco-Lao Ltd (BFL)"
      },
      {
        code: "JDBKLALA",
        name: "JOINT DEVELOPMENT BANK (JDB)",
        name_en: "JOINT DEVELOPMENT BANK (JDB)"
      },
      {
        code: "IDCBLALA",
        name: "INDOCHINA BANK LTD",
        name_en: "INDOCHINA BANK LTD"
      },
      {
        code: "STBDLALA",
        name: "ST BANK LTD",
        name_en: "ST BANK LTD"
      },
      {
        code: "LAOVLALA",
        name: "Lao-Viet Bank CO.,LTD",
        name_en: "Lao-Viet Bank CO.,LTD"
      }
    ];
  }
  static getBank(code) {
    const bank = new Banking();
    return bank.find(r => r.code === code);
  }
}
